import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Link, useLocation, useNavigate } from "react-router-dom";

import Grid from "@mui/material/Grid";
import Paper from "@mui/material/Paper";
import Typography from "@mui/material/Typography";

import { asTitle } from "utils/Utils";

import { activate } from "authentication/AuthenticationService";

const ActivationPage: React.FC = () => {
	const { t } = useTranslation();

	const navigate = useNavigate();
	const location = useLocation();

	const [activated, setActivated] = useState(false);
	const [failed, setFailed] = useState(false);

	useEffect(() => {
		const code = new URLSearchParams(location.search).get("code");

		if (code !== null) {
			activate(code)
				.then(() => setActivated(true))
				.catch(() => setFailed(true));
		} else {
			navigate("/login", { replace: true });
		}
	}, []);

	function getMessage(): string {
		if (activated) {
			return t("activationSucceeded");
		} else if (failed) {
			return t("activationFailed");
		}

		return t("activationPending");
	}

	return (
		<Grid container direction="row" justifyContent="center">
			<Grid item xs={12} sm={8} md={6} lg={4}>
				<Paper
					sx={{
						margin: 2,
						padding: 2,
						textAlign: "center"
					}}>
					<Typography variant="h5">
						{asTitle(t("activationTitle"))}
					</Typography>
					<Typography variant="body1">{getMessage()}</Typography>
					<Typography variant="body1">
						<Link to="/login">{t("toLogin")}</Link>
					</Typography>
				</Paper>
			</Grid>
		</Grid>
	);
};

export default ActivationPage;
